/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.id = void 0;
var id = '__row-expand-column';
exports.id = id;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/normalizeColumns/defaultRowExpandColumnId.js
// module id = 225
// module chunks = 0